import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ConvertHelper } from 'libs/abc/core/helpers';
import { AbcSplitterV2Component } from '../abc-splitter-v2/abc-splitter-v2.component';

@Component({
    selector: 'abc-side-nav',
    template: `
    <div fxLayout="row" fxFill style="height:100%; background-color: var(--LIGHTGRAY);">
      @if (showHeader) {
        <div class="sidNavMenu" [ngStyle]="{ order: rtlEnabled ? '2' : 'unset' }">
          <ng-content header> </ng-content>
        </div>
      }
    
      <abc-spl
        #splitter
        [orientation]="'horizontal'"
        [rtlEnabled]="rtlEnabled"
        (onResize)="onResize($event)"
        (onItemCollapsed)="onItemCollapsed($event)"
        (onItemExpanded)="onItemExpanded($event)"
        >
        <dxi-item [size]="opened ? '13%' : '0%'" maxSize="40%">
          <mat-drawer
            class="matDrawer"
            [(opened)]="opened"
            #drawer
            mode="side"
            [position]="position"
            style="minWidth:250px"
            >
            <ng-content select="[content=drawerContent]"></ng-content>
          </mat-drawer>
        </dxi-item>
        <dxi-item [collapsible]="true" [size]="opened ? '87%' : '100%'" [collapsedSize]="'60%'">
          <mat-drawer-container class="matDrawerContainer" autosize>
            <ng-content select="[content=drawerContainer]"></ng-content>
          </mat-drawer-container>
        </dxi-item>
      </abc-spl>
    </div>
    `,
    styleUrls: ['./abc-side-nav.component.scss'],
    standalone: false
})
export class _AbcSideNavComponent implements OnInit, AfterViewInit {
  @ViewChild('drawer', { static: true }) drawer: MatDrawer;
  @ViewChild('splitter', { static: true }) splitter: AbcSplitterV2Component;

  @Input() class: string;
  @Input() showHeader: boolean;
  @Input() set rtlEnabled(value: boolean) {
    this._rtlEnabled = value;
    this.position = value ? 'end' : 'start';
  }
  get rtlEnabled(): boolean {
    return this._rtlEnabled;
  }
  @Input() opened: boolean;
  @Input() openedStorageKey: string;

  @Output() resizeEvent = new EventEmitter<any>();
  @Output() itemCollapsedEvent = new EventEmitter<any>();
  @Output() itemExpandedEvent = new EventEmitter<any>();

  private lastActivatedItem: any;

  protected _rtlEnabled: boolean;
  protected position: string;
  ngOnInit() {
    if (this.openedStorageKey && !this.opened) {
      this.opened = ConvertHelper.toBoolean(sessionStorage.getItem(this.openedStorageKey));
    }
  }

  ngAfterViewInit(): void {
    const resizeHandle = this.splitter.elementRef.nativeElement.querySelector('.dx-resize-handle-horizontal');
    //Hide splitter bar when the side nav is closed
    if (!this.opened && resizeHandle) {
      resizeHandle.style.display = 'none';
    }
    const splitterItemDiv = this.splitter.instance.element().querySelector('.dx-item.dx-splitter-item') as HTMLElement;
    if (this.opened) {
      splitterItemDiv.style.minWidth = '250px';
    } else {
      splitterItemDiv.style.removeProperty('min-width');
    }
  }

  toggleMenu(state: boolean) {
    this.drawer.toggle(state);
  }

  public async setOpened(value: boolean): Promise<void> {
    if (this.openedStorageKey) {
      sessionStorage.setItem(this.openedStorageKey, ConvertHelper.toString(value));
    }
    this.opened = value;
    const resizeHandle = this.splitter.elementRef.nativeElement.querySelector('.dx-resize-handle-horizontal');

    if (value && resizeHandle) {
      resizeHandle.style.display = 'inherit';
    } else {
      resizeHandle.style.display = 'none';
    }
    const splitterItemDiv = this.splitter.instance.element().querySelector('.dx-item.dx-splitter-item') as HTMLElement;
    if (this.opened) {
      splitterItemDiv.style.minWidth = '250px';
    } else {
      splitterItemDiv.style.removeProperty('min-width');
    }
  }

  onResize(event: any) {
    this.resizeEvent.emit(event);
  }
  onItemCollapsed(event: any) {
    this.itemCollapsedEvent.emit(event);
  }

  onItemExpanded(event: any) {
    this.itemExpandedEvent.emit(event);
  }
}
